import * as uuid from 'uuid';

export const generateUid = (): string => uuid.v4();
